import Cookies from 'js-cookie';

(($) => {
  $(() => {
    const $announcementModal = $('#announcement-modal');

    if ($announcementModal.length) {
      const cookieName = 'announcementModal';
      const cookieOptions = { expires: 365 };
      const announcementType = $announcementModal.data('announcement-type');

      if (Cookies.get(cookieName) !== announcementType) {
        $announcementModal.modal('show');
        Cookies.set(cookieName, announcementType, cookieOptions);
      }
    }
  });
})(jQuery);
